import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/bUm2BAe77fxpZnnSa7DJ7J/reparaciones_mockup_sin_fondo-6.png';
export function Hero({
  ctaId
}: {
  ctaId: string;
}) {
  return <header className="w-full bg-cream px-4 pb-12 pt-8 sm:pt-12" data-id="element-124" data-mp="9igxnf29y0mt">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-125" data-mp="4n1oh0f7oswq">
        <div className="flex items-center gap-2" data-id="element-126" data-mp="128fqlljlahwr">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-navy font-display text-lg font-bold text-gold" data-id="element-127" data-mp="1274mfkm8f854">
            K
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-navy" data-id="element-128" data-mp="sa027qby5mqy">
            Dra. Karito
          </span>
        </div>

        <span className="mt-5 inline-block rounded-full bg-navy/5 px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.18em] text-navy/70 sm:text-xs" data-id="element-129" data-mp="nekqb3xi20x6">
          Kit Clínico para el Manejo de la Obesidad
        </span>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-4 font-display text-[32px] font-bold leading-[1.1] tracking-tight text-navy-900 sm:text-[52px] sm:leading-[1.06]" data-id="element-130" data-mp="3j7zcjaz8recz">
          Sigue una <span className="italic text-brandblue" data-id="element-131" data-mp="3e8mud3jbevgq">Ruta Clínica</span> que te permitirá tomar
          decisiones <span className="italic text-brandblue" data-id="element-132" data-mp="30hreh7aefe3n">más rápidas y seguras</span> en el manejo
          de la obesidad
        </motion.h1>

        <p className="mt-4 max-w-xl text-[17px] font-medium leading-snug text-navy/75 sm:text-2xl sm:leading-snug" data-id="element-133" data-mp="35a2fyeksf7yb">
          Sin depender de múltiples guías ni perder tiempo buscando información durante la consulta.
        </p>

        <p className="mt-4 max-w-xl text-[14px] leading-relaxed text-navy/60 sm:text-base" data-id="element-134" data-mp="2hj5ddsevtmzq">
          En un solo kit profesional encontrarás algoritmos de decisión, protocolos de tratamiento,
          checklists, casos clínicos y herramientas listas para aplicar desde tu próxima consulta.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} src={MOCKUP} alt="Kit Clínico para el Manejo de la Obesidad: 6 tomos impresos, tablet y teléfono con el material digital" className="mt-7 w-full max-w-[560px]" data-id="element-135" data-mp="nbba6qtxtx1l" />

        <div className="mt-6 w-full" data-id="element-136" data-mp="1b049mx9rqn0y">
          <CTAButton id={ctaId} sublabel="Hoy solo $12.99 USD • Descarga inmediata • Acceso de por vida • Garantía de 7 días" data-id="element-137" data-mp="1622l3wtkpvi3" />
        </div>
      </div>
    </header>;
}